import BASEURLGESTTOR from '../api/gesttor'
import { participarSugestaoPayload } from '../../interfaces/sugestao'


export function toogleSugestao (payload: participarSugestaoPayload) {
    return BASEURLGESTTOR.post('/suporte/sugestao', payload)
}

